<template>
  <div v-loading="$wait.waiting(_uid)" class="card training-program">
    <div class="card-content">

      <acl :tier="['premium']">
        <TrainingRecordExpiryNotes />
      </acl>

      <div class="flex lg:flex-row flex-col justify-between">
        <acl>
          <div class="flex lg:flex-row flex-col">
            <div class="lg:flex-row">
              <div class="flex ml-auto">
                <b class="mr-3">Display record for:</b>
                <el-date-picker
                  v-model="searchDate"
                  :picker-options="datePickerOptions"
                />
              </div>
            </div>
            <div class="flex ml-auto xs:flex-row">
              <button
                type="button"
                class="ml-3 btn btn-warning btn-wd submit-button lg:w-auto w-full xs:ml-8"
                @click="generate"
              >
                Generate
              </button>
            </div>
          </div>
        </acl>

        <div class="flex ml-auto">
          <acl :tier="['premium']">
            <div class="flex lg:flex-row flex-col">
              <button
                type="button"
                class="ml-3 btn btn-primary btn-wd submit-button lg:w-auto w-full xs:ml-8 hidden"
                @click="changeVersion"
              >
                <div v-if="version == 1">Cycle Version</div>

                <div v-if="version == 4">Old Version</div>
              </button>

<!--              <button-->
<!--                v-if="!user.international_procedures"-->
<!--                type="button"-->
<!--                class="btn btn-cancel btn-info btn-wd submit-button lg:w-auto w-full"-->
<!--                @click="download('complete_expanded')">-->
<!--&lt;!&ndash;                @click="download('complete')"&ndash;&gt;-->
<!--                Print-->
<!--              </button>-->

              <drop-down v-if="!user.international_procedures">
                <button
                  slot="title"
                  class="btn btn-cancel btn-info btn-wd submit-button lg:w-auto w-full dropdown-toggle"
                  data-toggle="dropdown"
                >
                  Print
                  <b class="caret"></b>
                </button>
                <li>
                  <a @click="download('complete')">Complete (Collapsed)</a>
                </li>
                <li>
                  <a @click="download('complete_expanded')">Complete (Expanded)</a>
                </li>
              </drop-down>

              <drop-down v-if="user.international_procedures">
                <button
                  slot="title"
                  class="btn btn-cancel btn-info btn-wd submit-button lg:w-auto w-full dropdown-toggle"
                  data-toggle="dropdown"
                >
                  Print
                  <b class="caret"></b>
                </button>
                <li>
                  <a @click="download('complete')">Complete (Collapsed)</a>
                </li>
                <li>
                  <a @click="download('complete_expanded')">Complete (Expanded)</a>
                </li>
                <li>
                  <a @click="download('international_procedures')">International Procedures</a>
                </li>
              </drop-down>
            </div>
          </acl>
        </div>
      </div>
      <div class="mt-5 row">
        <div class="col-sm-12">
          <acl :tier="['premium']">
            <PremiumTrainingRecord :data="records" :version="version" />
          </acl>
          <acl :tier="['essentials']">
            <EssentialsTrainingRecord
              :data="records"
              :version="version"
              @printCertificate="printCertificate"
              @downloadCertificate="downloadCertificate"
            />
          </acl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import PremiumTrainingRecord from "./Components/PremiumTrainingRecord";
import EssentialsTrainingRecord from "./Components/EssentialsTrainingRecord";
import { mapGetters, mapActions } from "vuex";
import HelperDate from "@helpers/dates";
import MyService from "@app/services/my";
import { saveAs } from "file-saver";
import _kebabCase from "lodash.kebabcase";
import TrainingRecordExpiryNotes from "./TrainingRecordExpiryNotes.vue";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    PremiumTrainingRecord,
    EssentialsTrainingRecord,
    TrainingRecordExpiryNotes
  },
  data() {
    const disabledDate = this.disabledDate;
    return {
      searchDate: this.moment(),
      datePickerOptions: {
        disabledDate,
      },
      records: {},
      version: null,
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("userStore", ["user"]),
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);

      // const migrationDate = this.moment(this.user.migration_date).startOf("day");
      // const createdAt = this.moment(this.user.created_at).startOf("day");
      // this.mimDate = createdAt < migrationDate ? createdAt : migrationDate;
      // this.mimDate = createdAt;

      this.mimDate = this.moment().subtract(3, "years").startOf("day");

      const endDay = this.moment().endOf("day");
      this.maxDate = this.user.deleted_at
        ? this.moment(this.user.deleted_at).endOf("day")
        : endDay;

      console.log({
        mimDate: this.mimDate.utc().format("YYYY-MM-DD"),
        maxDate: this.maxDate.utc().format("YYYY-MM-DD"),
      });

      this.version = this.user.training_record;
      await this.fetchRecords();
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    async fetchRecords() {
      this.records = await MyService.getRecords(
        this.parseDate(this.searchDate),
        this.version
      );
      const topicList = this.records.topics;
      if (!topicList) {
        this.records = {};
      }
    },
    async generate() {
      try {
        this.$wait.start(this._uid);
        await this.fetchRecords();
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    isPremium(version) {
      return version === 1;
    },
    parseDate(date) {
      return HelperDate.formatDate(date);
    },
    async print() {
      const routeData = this.$router.resolve({
        name: "my@records-print",
        query: { date: this.parseDate(this.searchDate), version: this.version },
      });
      window.open(routeData.href, "_blank");
    },
    async download(type) {
      try {
        this.$wait.start(this._uid);
        const date = this.parseDate(this.searchDate);
        const version = this.version;
        const filename = _kebabCase(`${this.user.fullName}-${date}`);
        const filetype = "application/pdf;charset=utf-8";

        const params = {
          date,
          version,
          type,
        };

        const response = await MyService.getRecordsDownload(params);

        const blob = new Blob(
          [response],
          { type: filetype },
          { autoBom: true }
        );
        saveAs(blob, filename);
      } catch (error) {
        this.addNewError(error);
        this.$wait.end(this._uid);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    async printCertificate(certificate) {
      const routeData = this.$router.resolve({
        name: "my@certificate-print",
        params: { hash: certificate.hash },
      });
      window.open(routeData.href, "_blank");
    },
    async downloadCertificate(certificate) {
      try {
        this.$wait.start(this._uid);
        const date = this.parseDate(this.searchDate);
        const filename = _kebabCase(`${this.user.fullName}-${date}`);
        const type = "application/pdf;charset=utf-8";

        const response = await MyService.getCertificateDownload(
          certificate.hash
        );

        const blob = new Blob([response], { type: type }, { autoBom: true });
        saveAs(blob, filename);
      } catch (error) {
        this.addNewError(error);
        this.$wait.end(this._uid);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    disabledDate(date) {
      // const migrationDate = this.moment(this.user.migration_date);
      const mimDate = this.moment(this.user.created_at);
      date = this.moment(date);
      const today = this.moment();
      return !(mimDate < date && date < today);
    },
    async changeVersion() {
      try {
        this.$wait.start(this._uid);

        if (this.version == 1) {
          this.version = 4;
          await this.fetchRecords();
          return;
        }

        if (this.version == 4) {
          this.version = 1;
          await this.fetchRecords();
          return;
        }
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
  },
};
</script>

<style lang="scss">
.btn-cancel {
  margin: 0;
}
</style>
